import Service from "../../adapters/xhr/Service";

export class AuthorizeService extends Service {
  constructor() {
    super("api/authenticate");
    this._user = null;
  }

  async signIn(username, password) {
    return await this.post("", { username, password }, (status, data) => {
      if (status >= 200 && status < 300) {
        return {
          status: AuthenticationResultStatus.Success,
        };
      }

      return {
        status: AuthenticationResultStatus.Fail,
        message: data?.message ?? "invalid_credential",
      };
    });
  }

  async getUser() {
    return await this.get("/GetCurrentUser", (status, data) => {
      if (status >= 200 && status < 300 && data) {
        this._user = data;
        return data;
      }

      this._user = null;
      return null;
    });
  }

  async isAuthenticated() {
    const user = await this.getUser();
    return !!user;
  }
  
  async signOut() {
    await this.post("/logout", null, () => {
      return true;
    });

    this._user = null;
    window.location.assign("/login");
  }

  logOut() {
    return this.signOut();
  }
}

const authService = new AuthorizeService();

export default authService;

export const AuthenticationResultStatus = {
  Success: "success",
  Fail: "fail",
};
